import { render, staticRenderFns } from "./wap.vue?vue&type=template&id=94410c2c&"
import script from "./wap.vue?vue&type=script&lang=js&"
export * from "./wap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports